import { axiosInstance } from 'apis';
import { getBaseURL } from 'utility/baseURL';

const baseURL = getBaseURL();

const EFilter = {
	filter: baseURL + '/keepasite/SuppliersFilter',
	provinceAndCity: baseURL + '/Keepaapp/Get_ProvinceAndCityList',
	category: baseURL + '/keepasite/AllCategories',
};

const searchAPIs = {
	filterers: (data, option = {}) => axiosInstance.post(EFilter.filter, data, option),
	provinces: (data, option = {}) =>
		axiosInstance.post(EFilter.provinceAndCity, data, {
			...option,
		}),
	categories: (data, option = {}) => axiosInstance.post(EFilter.category, data, option),
};

export { searchAPIs, EFilter };
